import * as React from "react";
import { HelmetProvider } from "react-helmet-async";

export const helmetContext = {};

type HelmetWrapperProviderProps = { children: React.ReactNode };

export const HelmetWrapperProvider = ({
  children,
}: HelmetWrapperProviderProps) => (
  <HelmetProvider context={helmetContext}>{children}</HelmetProvider>
);
